import { z } from 'zod'

export const ViewStateSchema = z.object({
  longitude: z.number(),
  latitude: z.number(),
  zoom: z.number(),
  bearing: z.number(),
  pitch: z.number(),
  padding: z
    .object({
      top: z.number(),
      bottom: z.number(),
      left: z.number(),
      right: z.number(),
    })
    .default({ top: 0, bottom: 0, left: 0, right: 0 }),
})
export type ViewState = z.infer<typeof ViewStateSchema>
